
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_SUB_CATEGORIES_FROM_CATEG = "GET_SUB_CATEGORIES_FROM_CATEG";




